import styled from 'styled-components'

export const Container = styled.div`
  > div {
    max-width: ${props => props.theme.maxWidth};
    margin: 0 auto;
    padding: 30px;
  }
`
